import React from 'react';
import Proptypes from 'prop-types';
import { VIEW_DATASET_SUMMARY, VIEW_DATASET_MEASUREMENT } from '../../../constants/saxs';
import { Table } from 'react-bootstrap';
import _ from 'lodash';
import 'react-table/react-table.css'

import DataCollectionListSummaryTableHeader from './DataCollectionListSummaryTableHeader';
import DataCollectionListMeasurementTableHeader from './DataCollectionListMeasurementTableHeader';
import DataCollectionListMeasurementTableRow from './DataCollectionListMeasurementTableRow';
import DataCollectionListSummaryTableRow from './DataCollectionListSummaryTableRow';

/** React component which renders a datacollection list */
class DataCollectionListPanel extends React.Component {
    constructor(props) {
        super(props);

        this.getDataCollectionsGroupedByDataCollectionId = this.getDataCollectionsGroupedByDataCollectionId.bind(this);
    }
    render() {
        if (this.props.view === VIEW_DATASET_SUMMARY) {
            return (
                <Table hover responsive condensed className='table border-header runListFont'>
                    <DataCollectionListSummaryTableHeader />
                    <tbody>
                        {_.map(this.getDataCollectionsGroupedByDataCollectionId(), (dataCollectionGroup, index) => {
                            return dataCollectionGroup.map((dataCollection, index2) => {
                                //render the run with a prop indicating the rowSpan for the first inex and 0 for the others.
                                return (<DataCollectionListSummaryTableRow
                                    dataCollection={dataCollection}
                                    experimentId={this.props.experimentId}
                                    proposal={this.props.proposal}
                                    sessionId={this.props.sessionId}
                                    token={this.props.token}
                                    rowStyle={{
                                        backgroundColor: (index % 2 === 0) ? '#FFFFFF' : '#F9F9F9',
                                        borderBottom: (index2 === 2) ? '2px solid #3892d3' : null
                                    }}
                                />);
                            })
                        })}
                    </tbody>
                </Table>)
        } else if (this.props.view === VIEW_DATASET_MEASUREMENT) {
            return (<Table bordered striped hover responsive className='runListFont'>
                <DataCollectionListMeasurementTableHeader />
                <tbody>
                    {_.map(this.getDataCollectionsGroupedByDataCollectionId(), (dataCollectionGroup) => {
                        return dataCollectionGroup.map((dataCollection) => {
                            //render the run with a prop indicating the rowSpan for the first inex and 0 for the others.
                            return (<DataCollectionListMeasurementTableRow
                                dataset={dataCollection} />);
                        })
                    })}
                </tbody>
            </Table>);
        }

        return null;
    }

    /** Get grouped dataset by datacollectionId. This helps finding the number of runs per dataset as required for the rendering. */
    getDataCollectionsGroupedByDataCollectionId() {
        //Groups datasets by datacollectionId. Result is an object : { "datacollectionId1":{ [dataset1, dataset2 }, "datacollectionId2":{ [dataset3] } }
        let datasetsGroupedByDataCollectionId = _.groupBy(this.props.dataCollections, dataCollection => { return dataCollection.dataCollectionId; });
        let finalArray = [];
        for (var dataCollectionId in datasetsGroupedByDataCollectionId) {
            // Sort runs based on dataCollection order
            datasetsGroupedByDataCollectionId[dataCollectionId] = _.orderBy(datasetsGroupedByDataCollectionId[dataCollectionId], ['MeasurementToDataCollection_dataCollectionOrder'], ['desc'])

            // add the rowSpan property to each run
            datasetsGroupedByDataCollectionId[dataCollectionId] = _.map(datasetsGroupedByDataCollectionId[dataCollectionId], (value, index) => {
                if (index === 0) {
                    value.rowSpan = datasetsGroupedByDataCollectionId[dataCollectionId].length;
                    // } else {
                    //     value.rowSpan = 1;
                }
                return value;
            })
            finalArray.push(datasetsGroupedByDataCollectionId[dataCollectionId])
        };

        // reverse the result because groupBy() sorts dataCollection by their id
        return finalArray.reverse();
    }
}

export default DataCollectionListPanel;

DataCollectionListPanel.proptypes = {
    /** Datacollections */
    dataCollections: Proptypes.array,
    /** experiment identifier */
    experimentId: Proptypes.number,
    /** ESRF session identifier */
    sessionId: Proptypes.string,
    /** dataset list view */
    view: Proptypes.string,
}


// WEBPACK FOOTER //
// ./src/components/saxs/DataCollection/DataCollectionListPanel.js